export const getFilename = filepath => {
  const pathParts = filepath.split("/");
  return pathParts[pathParts.length - 1];
};
